export default [
    {
        path: "/bn_index/:sports_id",
        name: "bn_index",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/bainian/Detail/index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"首页"
        }
    },
    {
        path: "/bn_care/:item_sub_id/:sports_id",
        name: "bn_care",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/bainian/Careshow/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"活动"
        }
    },
    {
        path: "/bn_join/:item_sub_id/:sports_id",
        name: "bn_join",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/bainian/Register/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"报名"
        }
    },
    {
        path: "/bn_vote/:item_sub_id/:sports_id",
        name: "bn_vote",
        props:true,
        component: () => import(/* webpackChunkName: "Orient" */"../views/bainian/Vote/index.vue"),
        meta: {
            title: "我要投票",
            showloading: true,
            requiresAuth: true
        }
    },
    {
        path: "/bn_rank/:item_sub_id/:sports_id",
        name: "bn_rank",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/bainian/Carerank/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"排行"
        }
    },
]
